import { createApi } from '@reduxjs/toolkit/query/react'
import customFetchBase from '../services/CustomFetchBase'

/**
 * API slice for handling license details operations.
 */
export const getLicenseDetailsApi = createApi({
    reducerPath: 'getLicenseDetailsApi',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        /**
         * Mutation to fetch the user's license summary details.
         * @param {Object} userData - The user data required for fetching the license summary.
         * @returns {Promise<any>} The license summary details for the user.
         */
        getLicenseSummaryDetailsApi: builder.mutation({
            query: (userData) => ({
                url: '/getMyLicenseSummary',
                method: 'POST',
                body: userData
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    await queryFulfilled
                } catch (error) {}
            }
        }),

        /**
         * Mutation to generate and download a CSV report for license details.
         * @param {Object} userData - The user data required to generate the license report.
         * @returns {Promise<any>} A CSV file containing license details.
         */
        downloadCsvApi: builder.mutation({
            query: (userData) => ({
                url: '/generateLicenseReport',
                method: 'POST',
                body: userData
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    await queryFulfilled
                } catch (error) {}
            }
        })
    })
})

/**
 * Auto-generated hooks for the defined mutations.
 */
export const { useGetLicenseSummaryDetailsApiMutation, useDownloadCsvApiMutation } = getLicenseDetailsApi
